<template>
  <div>
    <v-select
      id="group-solution-select"
      v-model="grupoSolucaoIds"
      item-text="nome"
      item-name="grupoSolucaoId"
      item-value="grupoSolucaoId"
      :items="gruopSolutions"
      :label="
        isAT
          ? 'Grupos de Iniciativas'
          : isGov
          ? 'Grupos de fases'
          : 'Grupos de Soluções'
      "
      :placeholder="
        isAT
          ? 'Grupos de Iniciativas'
          : isGov
          ? 'Grupos de fases'
          : 'Grupos de Soluções'
      "
      clearable
      @change="$emit('changeGroupSolution', grupoSolucaoIds)"
    >
      <template slot="no-data">
        Nenhum
        {{
          isAT
            ? "Grupo de Iniciativa"
            : isGov
            ? "Grupo de Fase"
            : "Grupo de Solução"
        }}
        Retornado
      </template>
    </v-select>
  </div>
</template>

<script>
import { groupSolutionAPI } from "../API/GroupSolutionAPI";
import { mapActions, mapGetters } from "vuex";
import { compare } from "@/helpers/orderByAsc";

export default {
  name: "AppGroupSolutionCombobox",
  props: ["filter", "groupSolution", "groupSolutionId"],
  mounted() {
    this.loadGroupSolution();
    this.grupoSolucaoIds = this.groupSolutionId;
  },
  computed: {
    ...mapGetters(["loading", "isAT", "isGov"]),
  },
  methods: {
    loadGroupSolution() {
      groupSolutionAPI
        .list()
        .then((resp) => {
          this.gruopSolutions = resp.data.sort((a, b) => compare(a, b, "nome"));
        })
        .catch();
    },
  },
  data() {
    return {
      gruopSolutions: [],
      grupoSolucaoIds: null,
    };
  },
  watch: {
    filter: {
      handler(val, oldVal) {
        this.grupoSolucaoIds = val.grupoSolucaoId;
      },
      deep: true,
    },
    groupSolutionId: function (val) {
      this.grupoSolucaoIds = val;
    },
    groupSolution: {
      handler(val, oldVal) {
        this.gruopSolutions = val;
      },
      deep: true,
    },
  },
};
</script>
